<template>
   <div>
     <apexchart ref="myChart" width="100%" :height="this.height ? this.height : 320" type="bar" :options="chartOptions" :series="series"></apexchart>
   </div>
</template>

<script>
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

export default {
    props:['categories', 'chartdata', 'legend', 'height', 'ycolor', 'xcolor',],
    data: function() {
      return {
        series: this.chartdata,
          chartOptions: {
            chart: {
                type: 'bar',
                height: this.height ? this.height : 350,
                width: '100%',
                toolbar: {
                    show: false,
                    tools:{
                        download:false // <== line to add
                    }
                },
                zoom: {
                    enabled: false
                },
                animations: {
                    enabled: false
                },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded'
              },
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
            xaxis: {
                categories: this.categories,
                labels: {
                    style: {
                        colors: this.ycolor ? this.ycolor : '#FFF'
                    }
                }
            },
            yaxis: {
                // logarithmic: true,
                labels: {
                    style: {
                        colors: this.xcolor ? this.xcolor : '#FFF'
                    }
                }
            },
            // fill: {
            //   opacity: 1
            // },
            legend: {
              show: this.legend ? true : false,
              position: 'bottom',
              horizontalAlign: 'center',
              floating: false,
              offsetY: 0,
              offsetX: 0
            },
            colors: ["#0cbcf2", "#003565", "#7041e5", "#b8c3d0", "#beaeff"]
          },
      }
    },
    watch: {
        categories: (newVal, oldVal) => {
            // this.$nextTick(() => {
            //     this.$refs.myChart.refresh();
            // });
        },
        series: (newVal, oldVal) => {
            // this.$nextTick(() => {
            //     this.$refs.myChart.refresh();
            // });
        }
    }
};
</script>